export interface Credentials {
  username: string
  password: string
}
export enum UserRole {
  ALL = "all",
  USER = "user",
  HYRIS = "hyris",
  GEEK = "geek", // ADMIN
}

export interface AuthSession {
  role: UserRole
  user: number
  username: string
  gdaAccess: boolean
}
